import { render, staticRenderFns } from "./DetailsOfAgriculturalMonthIncomePersonal.vue?vue&type=template&id=0e40cead&"
import script from "./DetailsOfAgriculturalMonthIncomePersonal.vue?vue&type=script&lang=js&"
export * from "./DetailsOfAgriculturalMonthIncomePersonal.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOfAgriculturalMonthIncomePersonal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports